import React from 'react'
import { useFormContext } from 'react-hook-form'
import { PricingFacet } from 'services/api/entities/catalog/facets'
import { FoodUpselling } from 'services/api/entities/catalog/foodUpselling/types/internal/foodUpselling-models'
import { getById } from 'services/utils'
import useFacets from 'ui-shared/Facets/BaseComponents/useFacets'
import QuantityHintForm from 'ui-shared/Hints/QuantityHint/QuantityHintForm'

const UpsellingHintInput: React.FC = () => {
  const { watch, setValue } = useFormContext<FoodUpselling>()
  const pricingFacets = useFacets<PricingFacet>('pricing')
  const pricingFacet = watch('pricingFacet')

  const selectedPricingFacet = getById(pricingFacets, pricingFacet!)

  // Quantity Hint is available only on "perItem" upsellings
  const isPerItem = selectedPricingFacet?.pricingType === 'perItem'
  setValue('isPerItem', isPerItem ?? false)

  return !!isPerItem ? (
    <QuantityHintForm
      accordionText={[
        'quantityUpsellingHintAccordionText1',
        'quantityUpsellingHintAccordionText2',
        'quantityUpsellingHintAccordionText3',
        'quantityUpsellingHintAccordionText4',
      ]}
    />
  ) : null
}

export default UpsellingHintInput
